import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c69e71f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid p-5 justify-content-center align-content-start" }
const _hoisted_2 = { class: "col-12 lg:col-5 xl:col-5" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_header_card = _resolveComponent("header-card")
  const _component_p_image = _resolveComponent("p-image")
  const _component_p_pdf = _resolveComponent("p-pdf")
  const _component_p_yt = _resolveComponent("p-yt")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[_ctx.showGif ? 'background-animasi' : 'background-animasi-end'], "overflow-y-auto"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_header_card, {
          is_loading: _ctx.is_loading,
          title: "Profil Kami",
          icon: "🏥",
          subtitle: "INSTALASI GIZI RSUD dr. Soeroto Ngawi",
          clickable: true,
          route: "/home"
        }, null, 8, ["is_loading"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "img-profil"
          }, [
            (item.file != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.categorizeFiles(item) == 'image')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: item.file
                      }, [
                        _createVNode(_component_p_image, {
                          src: item.url_cors,
                          alt: "Image",
                          width: "100%",
                          preview: ""
                        }, null, 8, ["src"])
                      ]))
                    : (_ctx.categorizeFiles(item) == 'pdf')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: item.file
                        }, [
                          (item.url_cors)
                            ? (_openBlock(), _createBlock(_component_p_pdf, {
                                key: 0,
                                src: item.url_cors
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_p_yt, {
                  key: 1,
                  url: item.url
                }, null, 8, ["url"]))
          ]))
        }), 128))
      ])
    ])
  ], 2))
}